const themeColors = {
  brand: '#0099CC',
  shamrock: '#009900',
  barney: '#cc3399',
  crimson: '#CC0000',
  orange: '#FF6600',
  midnightBlue: '#003366',
  gray20: '#333333',
  ash: '#999999',
  tiara: '#CCCCCC'
}

export { themeColors }
